import { AssetType } from '../types/asset.type';

export interface IPolicy {
  insurer_id: string;
  claims_preparation_cost_reimbursed: IPolicyItem;
  claim_within: IPolicyItem;
  proof_of_ownership_requirement: IPolicyItem;
  no_claim_bonus: IPolicyItem;
  policy_house_contents: IPolicyHouseContents;
  policy_all_risk: IPolicyAllRisk;
  policy_buildings: IPolicyBuildings;
  policy_vehicles: IPolicyVehicles;
  policy_third_party_libility: IPolicyThirdPartyLibility;
  legal_costs_and_legal_expenses: IPolicyItem;
  personal_accident: IPolicyItem;
  death_benefit_plan: IPolicyItem;
  hospital_benefit_plan: IPolicyItem;
}

export interface IPolicyItem {
  description: string;
  covered: string;
  paragraph: string;
}

export interface ICancelPolicyAsset {
  asset_info: string;
  asset_type: AssetType;
  brolink_asset_id: string;
  policy_id: string;
  asset_id: number;
}

export interface IPolicyHouseContents {
  household_contents: IPolicyItem;
  personal_property: IPolicyItem;
  fixtures_and_fittings: IPolicyItem;
  burglary: IPolicyItem;
  theft_and_attempted_theft: IPolicyItem;
  theft_from_outbuildings: IPolicyItem;
  fire: IPolicyItem;
  ligthning: IPolicyItem;
  explosion: IPolicyItem;
  malicious_damage: IPolicyItem;
  malicious_damage_while_residence_is_lent_or_let: IPolicyItem;
  storm: IPolicyItem;
  wind: IPolicyItem;
  water: IPolicyItem;
  hail: IPolicyItem;
  snow: IPolicyItem;
  process_using_water: IPolicyItem;
  wear_and_tear: IPolicyItem;
  gradual_deterioration: IPolicyItem;
  mildew: IPolicyItem;
  rust: IPolicyItem;
  corrosion: IPolicyItem;
  earthquake: IPolicyItem;
  objects_hitting_your_residence: IPolicyItem;
  falling_trees: IPolicyItem;
  falling_trees_felled_by_someone: IPolicyItem;
  breakage_of_aerial_systems: IPolicyItem;
  oil_heater_leakage: IPolicyItem;
  money: IPolicyItem;
  when_outside_your_residence: IPolicyItem;
  temporary_increase_in_cover_dec_jan: IPolicyItem;
  debris_removal: IPolicyItem;
  rent_for_alternative_accommodation: IPolicyItem;
  fire_extinguishing_charges: IPolicyItem;
  mirrors_and_certain_glass_cover: IPolicyItem;
  death_within_90_days_cover: IPolicyItem;
  veterinary_expenses_following_road_accident: IPolicyItem;
  damage_by_wild_baboons_or_monkeys: IPolicyItem;
  medical_expenses_of_guests: IPolicyItem;
  medical_expenses_of_domestic_employees: IPolicyItem;
  personal_effects_of_guests: IPolicyItem;
  personal_effects_of_domestic_employees: IPolicyItem;
  contents_of_fridge_freezer: IPolicyItem;
  storage_costs_for_contents_after_damage: IPolicyItem;
  trauma_treatment_for_theft_burglary_hijacking_or_fire: IPolicyItem;
  cost_of_guards_following_insured_event: IPolicyItem;
  extension_for_limited_band_b_cover: IPolicyItem;
  stock_in_trade_of_your_home_industry: IPolicyItem;
  accidental_damage: IPolicyItem;
  subsidence_and_landslip: IPolicyItem;
  inflation_protection_monthly: IPolicyItem;
}

export interface IPolicyAllRisk {
  clothing_and_personal_effects: IPolicyItem;
  specified_items: IPolicyItem;
  mobile_devices: IPolicyItem;
  computers: IPolicyItem;
  portable_gaming_electronic_equipment: IPolicyItem;
  stamp_medal_and_coin_collections: IPolicyItem;
  keys_access_cards_remote_controls: IPolicyItem;
  bicycles_and_wheelchairs: IPolicyItem;
  theft_of_clothing_from_washing_line: IPolicyItem;
  gardening_equiment_controlled_by_driver: IPolicyItem;
  surfboards_kiteboards_paddleskis_etc: IPolicyItem;
}

export interface IPolicyBuildings {
  burglary: IPolicyItem;
  theft_and_attempted_theft: IPolicyItem;
  fire: IPolicyItem;
  ligthning: IPolicyItem;
  explosion: IPolicyItem;
  malicious_damage: IPolicyItem;
  malicious_damage_while_residence_is_lent_or_let: IPolicyItem;
  storm: IPolicyItem;
  wind: IPolicyItem;
  water: IPolicyItem;
  hail: IPolicyItem;
  snow: IPolicyItem;
  process_using_water: IPolicyItem;
  wear_and_tear: IPolicyItem;
  gradual_deterioration: IPolicyItem;
  mildew: IPolicyItem;
  rust: IPolicyItem;
  corrosion: IPolicyItem;
  soil_movement_due_do_water_content: IPolicyItem;
  earthquake: IPolicyItem;
  bursting_of_water_tanks_or_pipes: IPolicyItem;
  objects_hitting_your_residence: IPolicyItem;
  falling_trees: IPolicyItem;
  falling_trees_felled_by_someone: IPolicyItem;
  breakage_of_aerial_systems: IPolicyItem;
  oil_heater_leakage: IPolicyItem;
  subsidence_and_land_slide: IPolicyItem;
  debris_removal: IPolicyItem;
  rent_for_alternative_accommodation: IPolicyItem;
  fire_extinguishing_charges: IPolicyItem;
  mirrors_and_certain_glass_cover: IPolicyItem;
  professional_fees_and_demolition_costs: IPolicyItem;
  public_supply_or_mains_connections: IPolicyItem;
  loss_of_water_due_to_leaking_pipes: IPolicyItem;
  removal_of_fallen_trees: IPolicyItem;
  tracing_of_leaks: IPolicyItem;
  special_alterations_for_wheelchair: IPolicyItem;
  cover_before_property_transfer: IPolicyItem;
  damage_by_wild_baboons_monkeys: IPolicyItem;
  loss_of_rent: IPolicyItem;
  aerials: IPolicyItem;
  medical_expenses_of_guests: IPolicyItem;
  medical_expenses_of_domestic_employees: IPolicyItem;
  damage_to_gardens: IPolicyItem;
  emergency_accommodation: IPolicyItem;
  cost_of_guards_following_insured_event: IPolicyItem;
  accidental_damage_to_fixed_machinery: IPolicyItem;
  subsidence_and_landslip_comprehensive_cover_extension: IPolicyItem;
  inflation_protection_monthly: IPolicyItem;
  matching_building_material: IPolicyItem;
}

export interface IPolicyVehicles {
  comprehensive: IPolicyItem;
  comprehensive_cxcl_theft_and_hijack: IPolicyItem;
  third_party_fire_lightning_explosion_theft_or_hijack: IPolicyItem;
  thirdparty_only: IPolicyItem;
  tow_in_and_safeguarding: IPolicyItem;
  emergency_repairs: IPolicyItem;
  delivery_to_home_after_repairs: IPolicyItem;
  tow_in_cost_and_safeguarding_after_mechanical_breakdown: IPolicyItem;
  vehicle_transfer_cover: IPolicyItem;
  replacement_of_vehicle_in_first_12_months: IPolicyItem;
  difference_in_excess_cover_for_rented_vehicle: IPolicyItem;
  loss_of_keys: IPolicyItem;
  medical_expenses_of_passengers_other_than_your_family: IPolicyItem;
  emergency_accommodation: IPolicyItem;
  costs_for_emergency_services: IPolicyItem;
  recovery_costs_after_theft_or_hijack: IPolicyItem;
  medical_expenses_of_passengers_your_family: IPolicyItem;
  trauma_treatment_after_hiJacking: IPolicyItem;
  specified_motor_accessories: IPolicyItem;
  credit_shortfall: IPolicyItem;
  contents_of_caravan_trailer: IPolicyItem;
  tools_spare_parts_and_travel_accessories: IPolicyItem;
  car_hire: IPolicyItem;
  four_by_four_cover_extension: IPolicyItem;
  luxury_vehicle_cover_extension: IPolicyItem;
  hail_cover: IPolicyItem;
  third_party_legal_liability_you_using_your_vehicle: IPolicyItem;
  third_party_legal_liability_someone_else_using_your_vehicle: IPolicyItem;
  third_party_legal_liability_you_using_someone_elses_vehicle: IPolicyItem;
  third_party_legal_liability_motorcycle_passanger: IPolicyItem;
  third_party_legal_liability_passenger_in_load_body_of_ldv: IPolicyItem;
}

export interface IPolicyThirdPartyLibility {
  personal_legal_liability: IPolicyItem;
  persona_legal_liability_for_wrongful_arrest: IPolicyItem;
  unlawful_use_of_your_credit_purchase_or_sim_cards: IPolicyItem;
  hole_in_one_in_golf: IPolicyItem;
  full_house_in_bowls: IPolicyItem;
  personal_legal_liability_to_domestic_employees: IPolicyItem;
  tenant_liability: IPolicyItem;
  security_companies: IPolicyItem;
  extended_personal_legal_liability: IPolicyItem;
}

export interface IEmergencyNumberItem {
  description: string;
  telephone: string;
}

export interface IEmergencyNumber {
  [insurer_id: string]: IEmergencyNumberItem;
}

export interface IDealershipNumbers {
  description: string;
  value: string;
}

export interface IDealerships {
  [dealership: string]: IDealershipNumbers;
}

export interface IPolicyBenefitGroupItem {
  description: string;
  values: string;
}

export interface IPolicyBenefitGroup {
  description: string;
  group_items: Array<IPolicyBenefitGroupItem>;
  sub_benefit_group: IPolicyBenefitGroup;
  type: string;
}

export interface IPolicyBenefit {
  description: string;
  benefit_groups: Array<IPolicyBenefitGroup>;
}

export interface IRandomClause {
  items: any;
}

export interface IReferral {
  preferred_name: string;
  surname: string;
  email: string;
}

export interface IT2wofItem {
  description: string;
  items: Array<string>;
}

export interface IT2wof {
  [insurer_id: string]: IT2wofItem;
}

export interface IAmendment {
  effective_date: number;
  vehicle_ids: Array<string>;
  building_ids: Array<string>;
  content_ids: Array<string>;
  specified_item_ids: Array<string>;
  motorcycle_ids: Array<string>;
  caravan_ids: Array<string>;
}
